Shopify.queryParams = {};

/**
 * Refresh the collection page with the provided filters.
 *
 * @param {string} url_filters - The URL parameters for the filters.
 */
function refreshCollectionPageWithFilters(url_filters, submitMobile) {
	let currentUrl = "//" + location.host + location.pathname;
	let newPageString = httpGet(currentUrl + "?" + url_filters);
	let newPageEl = document.createElement("DIV");
	newPageEl.innerHTML = newPageString;

	//Recharge la grid
	if (window.innerWidth > 1024 || submitMobile === true) {
    var newSection = newPageEl.querySelector(".mm-grid-pagination-container");
    document.querySelector(".mm-grid-pagination-container").innerHTML = newSection.innerHTML;
  }

	let newFilters = newPageEl.querySelectorAll(".filter-group-display__list");
	newFilters.forEach((newFilter, index) => {
		document.querySelectorAll(".filter-group-display__list")[index].innerHTML = newFilter.innerHTML;
	});

	let pagination = newPageEl.querySelector(".pagination-wrapper");
	if (pagination) {
		let paginationTarget = document.querySelector(".pagination-wrapper");
		if (paginationTarget) {
			paginationTarget.innerHTML = pagination.innerHTML;
		}
	}

	window.history.replaceState(null, document.title, currentUrl + "?" + url_filters);
}

/**
 * Perform a synchronous GET request.
 *
 * @param {string} theUrl - The URL to request.
 * @returns {string} - The response text from the request.
 */
function httpGet(theUrl) {
	var xmlHttp = new XMLHttpRequest();
	xmlHttp.open("GET", theUrl, false);
	xmlHttp.send(null);
	return xmlHttp.responseText;
}

/**
 * Check for changes in the filter inputs and submit the form if changes are detected.
 */
function checkForChanges() {
  let formSortBy = document.getElementById("collectionSortByForm");

  var select = formSortBy.querySelector(".sort_by");
  select.addEventListener("change", function (e) {
    setTimeout(() => {
      fakeSubmitForm();
    }, "1");
  });
}

window.addEventListener("DOMContentLoaded", (event) => {
  checkForChanges();
});

/**
 * Adds an event listener to all elements with the class 'sort_by'.
 * When the value of a 'sort_by' element changes, it updates the sort_by query parameter
 * in the URL and reloads the page with the new sorting applied.
 */
// document.querySelector(".sort_by").addEventListener("change", function (e) {
// 	var value = e.target.value;
// 	Shopify.queryParams.sort_by = value;
// 	location.search = new URLSearchParams(Shopify.queryParams).toString();
// });

/**
 * Serialize the form data and refresh the collection page with the filters.
 */
function fakeSubmitForm(submitMobile = false) {
	let url_filters = $("#collectionFacetsForm").serialize();
    console.log(url_filters);
    let url_sort_by = $('#collectionSortByForm').serialize();
    console.log(url_sort_by);
    let url_filters_final = url_sort_by + "&" + url_filters;
	// refreshCollectionPageWithFilters(url_filters_final, submitMobile);

	    // Rafraîchir la collection avec les filtres
		setTimeout(() => {
			refreshCollectionPageWithFilters(url_filters_final, submitMobile);
		}, "0");
}

// Functions for handling mobile filter drawer
if (window.innerWidth < 1024) {
	/**
   * Open the mobile filters drawer.
  */
	const ctaOpenFilter = document.querySelector(".mm-collection-filter-button");
  const wrapperMobile = document.querySelector(".mm-collection-facets-container");
  const ctaCloseFilter = wrapperMobile.querySelectorAll(".mm-collection-close-btn");


	function mmOpenFiltersMobile() {
		wrapperMobile.classList.add("mm-open");
		document.querySelector("html").classList.add("stop-scrolling");
	}

  ctaOpenFilter.addEventListener("click", (event) => {
    mmOpenFiltersMobile();
  });


	/**
	 * Close the mobile filters drawer.
	 */
	function mmCloseFiltersMobile() {
		wrapperMobile.classList.remove("mm-open");

		document.querySelector("html").classList.remove("stop-scrolling");
	}

  ctaCloseFilter.forEach((cta) => {
		cta.addEventListener("click", (event) => {
			mmCloseFiltersMobile();
		});
  });

	/**
	 * Check if the URL contains the 'open_filters' parameter and open the mobile filters drawer if it does.
	 */
	function mmCheckDrawer() {
		var currentUrl = document.location.href.indexOf("?open_filters");
		if (currentUrl !== -1) {
			mmOpenFiltersMobile();
		}
	}
}

// update count filter
document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('collectionFacetsForm');
    const submitBtn = document.querySelector('.mm-drawer-collection-submit-btn');
    const totalProductsCollection = parseInt(form.dataset.totalProducts, 10);

    function updateProductCount() {
        const checkedFilters = form.querySelectorAll('input[type="checkbox"]:checked:not(:disabled)');
        let totalProducts = 0;

        checkedFilters.forEach(input => {
            const count = parseInt(input.dataset.count, 10);
            if (!isNaN(count)) {
                totalProducts += count;
            }
        });

        // Si aucun filtre n’est coché, on prend le total global
        if (checkedFilters.length === 0) {
            totalProducts = totalProductsCollection;
        }

        // Texte standardisé
        submitBtn.textContent = `AFFICHER ${totalProducts} PRODUITS`;
    }

    // Écoute les changements
    form.addEventListener('change', function(e) {
        if (e.target.matches('input[type="checkbox"]')) {
            updateProductCount();
        }
    });

    // Init au chargement
    updateProductCount();
});
    // Mise à jour des autres éléments avec la classe 'mm-reload'
    var reloadElems = newPageEl.querySelectorAll('.mm-reload');
    reloadElems.forEach(function (reloadElem, index) {
        var newElems = document.querySelectorAll('.mm-reload');
        newElems[index].innerHTML = reloadElem.innerHTML;
    });

